import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Typography,
  Input,
  Button,
  Select,
  Form,
  Col,
  Row,
  DatePicker,
  message,
  Table,
  Radio,
  Popconfirm,
} from "antd";
import moment from "moment";
import { platformApi } from "../../../../../api";
import { getUUID } from "../../../../../_helpers/utils";
import GSTTable from "./GSTTable";
import { GST18, GST28, GST12, GST5, formatValue } from "../../../../../utils";
import "./index.less";
import { useBranch } from "../../../../../ContextAPI/branch";
const { Title } = Typography;
const { Option } = Select;
const { Group } = Radio;
const InvoiceForm = (props) => {
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
  const history = useHistory();
  const location = useLocation();
  const {
    supplier,
    partsData,
    form,
    id,
    editData,
    editable,
    onEdit,
    modifyType,
    setSearch,
    setPartSearch,
    modifyAccess,
  } = props;
  const { getFieldDecorator } = form;
  const partItemData = {
    id: getUUID(),
    partNumber: {},
    hsn: {},
    quantity: "",
    unitRate: "",
    discount: "",
    rate: "",
    igst: 0,
    cgst: 0,
    sgst: 0,
    gstRate: 0,
    grandTotal: 0,
    igstAmount: 0,
    cgstAmount: 0,
    sgstAmount: 0,
    discountAmount: 0,
    discountPercent: 0,
    remove: "",
  };

  const { selectBranch } = useBranch();
  const [itemList, setItemList] = useState([partItemData]);
  const [selectItemObj, setSelectItemObj] = useState({});
  const [invoiceNumber, setInvoiceNumber] = useState();
  const [gst, setGst] = useState();
  const [invoiceDate, setInvoiceDate] = useState(
    !editData ? moment(Date.now()) : ""
  );
  const [supplierID, setSupplier] = useState();
  const [discountLevel, setDiscountLevel] = useState("percent");
  const [tax, setTax] = useState("Tax Exclusive");
  const [discountType, setDiscountType] = useState("At Transaction Level");
  const [quantity, setquantity] = useState();
  const [unitRate, setUnitRate] = useState();
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [grandTtl, setGrandTotal] = useState(0);
  const [adjustments, setAdjustments] = useState(0);
  const [totalInvoice, setTotalInvoice] = useState();
  const [stateName, setStateName] = useState();
  const [SGST, setSGST] = useState();
  const [CGST, setCGST] = useState();
  const [IGST, setIGST] = useState();
  const [GSTRate18, setGSTRate18] = useState(false);
  const [GSTRate28, setGSTRate28] = useState(false);
  const [GSTRate12, setGSTRate12] = useState(false);
  const [GSTRate5, setGSTRate5] = useState(false);
  const [SGSTAmount, setSGSTAmount] = useState();
  const [CGSTAmount, setCGSTAmount] = useState();
  const [IGSTAmount, setIGSTAmount] = useState();
  const [TCS, setTCS] = useState(0);
  const [deleteItem, setDeleteItem] = useState(false);
  const [formSubmit, setFormSubmit] = useState(false);
  const [branch, setBranch] = useState(
    selectBranch && selectBranch[0] ? selectBranch[0] : ""
  );
  const [error, setError] = useState({});
  const partNumberSelectRef = useRef(null);
  const [btnFlag, setBtnFlag] = useState(false);
  const [deletePartData, setDeletePartData] = useState([]);
  const [psiNo, setPsiNo] = useState("");
  const [invoiceNumberError, setInvoiceNumberError] = useState("");

  const partsRef = {};
  let totalAdjustments = 0;
  let tcs = 0;
  let sgstAmt = 0;
  let cgstAmt = 0;
  let igstAmt = 0;

  const roundOf = (number) => {
    if (number == null) return number;
    const roundedNumber = parseFloat(number).toFixed(2);
    return parseFloat(roundedNumber);
  };

  useEffect(() => {
    const obj = {};
    for (const item of itemList) {
      if (item.partNumber && item.partNumber.id) {
        obj[item.partNumber.id] = true;
      }
    }
    setSelectItemObj(obj);
  }, [itemList]);

  useEffect(() => {
    if (location.state) {
      setGst(location.state.gst);
    }
  }, [location.state]);

  useEffect(() => {
    if (branch && branch.gst) {
      setGst(branch.gst);
    }
  }, [branch]);

  let branchOptions = selectBranch ? [...selectBranch] : [];
  if (
    editData &&
    editData.purchaseItemInvoice &&
    editData.purchaseItemInvoice[0] &&
    editData.purchaseItemInvoice[0].branch
  ) {
    const editBranch = editData.purchaseItemInvoice[0].branch;
    const exists = branchOptions.some((b) => b.id === editBranch.id);
    if (!exists) {
      branchOptions.push(editBranch);
    }
  }

  useEffect(() => {
    if (editData) {
      setInvoiceNumber(editData.invoiceNumber || null);
      setInvoiceDate(
        editData && editData.invoiceDate
          ? moment(
            new Date(editData.invoiceDate && editData.invoiceDate)
          ).format("YYYY-MM-DD")
          : null
      );
      setDiscountType(editData.discountType);
      setTax(editData.itemRate);
      setTCS(editData.tcs);
      setAdjustments(editData.adjustment);
      setSupplier(editData && editData.supplier ? editData.supplier.name : "");
      setStateName(
        editData && editData.supplier && editData.supplier.GSTIN ? editData.supplier.GSTIN : ""
      );
      if (editData.discountType === "At Transaction Level") {
        const pct = parseFloat(editData.discountPercent) || 0;
        const rate = parseFloat(editData.discountRate) || 0;
        if (pct !== 0) {
          setDiscountAmount(pct);
          form.setFieldsValue({ discountAmount: pct });
        } else if (rate !== 0) {
          setDiscountAmount(rate);
          form.setFieldsValue({ discountAmount: rate });
        } else {
          setDiscountAmount(0);
          form.setFieldsValue({ discountAmount: 0 });
        }
      } else if (editData.discountType === "At Item Level") {
        const itemPct = parseFloat(editData.purchaseItemInvoice[0]?.discountPercent) || 0;
        const itemAmt = parseFloat(editData.purchaseItemInvoice[0]?.discountAmount) || 0;
        if (itemPct !== 0) {
          setDiscountLevel("percent");
        } else if (itemAmt !== 0) {
          setDiscountLevel("rupee");
        }
      }
      setTotalDiscount(parseFloat(editData.totalDiscount) || 0);
      setTotalInvoice(editData.totalInvoice);
      setPsiNo(editData.psiNo);
      if (
        editData.purchaseItemInvoice &&
        editData.purchaseItemInvoice.length > 0 &&
        editData.purchaseItemInvoice[0].branch &&
        (!branch || branch.id !== editData.purchaseItemInvoice[0].branch.id)
      ) {
        setBranch(editData.purchaseItemInvoice[0].branch);
      }
      form.setFieldsValue({
        totalInvoice: editData.totalInvoice,
      });
      const updateItemList = [...editData.purchaseItemInvoice];
      for (let i = 0; i < updateItemList.length; i++) {
        updateItemList[i].rate =
          updateItemList[i].quantity * updateItemList[i].unitRate;
        if (updateItemList[i].gstRate === GST28) {
          setGSTRate28(true);
        }
        if (updateItemList[i].gstRate === GST18) {
          setGSTRate18(true);
        }
        if (updateItemList[i].gstRate === GST12) {
          setGSTRate12(true);
        }
        if (updateItemList[i].gstRate === GST5) {
          setGSTRate5(true);
        }
      }
      if (editData.discountType === "At Item Level") {
        for (let i = 0; i < updateItemList.length; i++) {
          if (
            updateItemList[i].discountPercent &&
            updateItemList[i].discountPercent !== 0
          ) {
            updateItemList[i].discount = updateItemList[i].discountPercent;

            const qty = parseFloat(updateItemList[i].quantity) || 0;
            const unit = parseFloat(updateItemList[i].unitRate) || 0;
            const disc = parseFloat(updateItemList[i].discount) || 0;
            let original = qty * unit;
            let discounted = original * (1 - disc / 100);
            updateItemList[i].rate = discounted;
          } else if (
            (updateItemList[i].discountAmount &&
              updateItemList[i].discountAmount !== 0) ||
            (updateItemList[i].discountRate &&
              updateItemList[i].discountRate !== 0)
          ) {
            updateItemList[i].discount =
              updateItemList[i].discountAmount ||
              updateItemList[i].discountRate;

            const qty = parseFloat(updateItemList[i].quantity) || 0;
            const unit = parseFloat(updateItemList[i].unitRate) || 0;
            const disc = parseFloat(updateItemList[i].discount) || 0;
            let original = qty * unit;
            let discounted = original - disc;
            updateItemList[i].rate = discounted;
          } else {
            updateItemList[i].discount = 0;
            // No discount
            const qty = parseFloat(updateItemList[i].quantity) || 0;
            const unit = parseFloat(updateItemList[i].unitRate) || 0;
            updateItemList[i].rate = qty * unit;
          }
        }
      }
      setItemList([...updateItemList, partItemData]);
    }
  }, [editData]);

  useEffect(() => {
    if (discountType !== "At Transaction Level") return;
    let changed = false;
    const newItemList = itemList.map((item) => {
      if (item.quantity < 1 || item.unitRate < 1) return item;
      const basePrice =
        (parseFloat(item.quantity) || 0) * (parseFloat(item.unitRate) || 0);
      const discountedPrice =
        basePrice * (1 - (parseFloat(discountAmount) || 0) / 100);
      
      const { igstAmount, cgstAmount, sgstAmount } = getGstAmounts(discountedPrice, item);
      const newRate = roundOf(discountedPrice);

      if (
        item.rate !== newRate ||
        item.igstAmount !== igstAmount ||
        item.cgstAmount !== cgstAmount ||
        item.sgstAmount !== sgstAmount
      ) {
        changed = true;
      }

      return {
        ...item,
        rate: newRate,
        igstAmount,
        cgstAmount,
        sgstAmount,
      };
    });

    if (changed) {
      setItemList(newItemList);
    }
  }, [discountAmount, tax, discountType, itemList, stateName, gst]);

  useEffect(() => {
    let grandTotal = 0;
    
    if (discountType === "At Transaction Level" && itemList.length > 0) {
      let discountPercent = parseFloat(discountAmount) || 0;
      
      itemList.forEach((item) => {
        let baseRate =
          (parseFloat(item.quantity) || 0) * (parseFloat(item.unitRate) || 0);
        let discountedRate = baseRate;
        if (discountPercent > 0) {
          discountedRate = baseRate * (1 - discountPercent / 100);
        }
        discountedRate = roundOf(discountedRate);
        
        const { igstAmount, cgstAmount, sgstAmount } = getGstAmounts(discountedRate, item);
        
        if (tax === "Tax Inclusive") {
          grandTotal += discountedRate;
        } else {
          grandTotal += (discountedRate + igstAmount + cgstAmount + sgstAmount);
        }
      });
    } else {
      // Calculate base grand total from items for Item Level or No discount
      for (let i = 0; i < itemList.length; i++) {
        const rate = parseFloat(itemList[i].rate) || 0;
        const igstAmount = parseFloat(itemList[i].igstAmount) || 0;
        const cgstAmount = parseFloat(itemList[i].cgstAmount) || 0;
        const sgstAmount = parseFloat(itemList[i].sgstAmount) || 0;
        
        if (tax === "Tax Inclusive") {
          grandTotal += rate;
        } else {
          grandTotal += (rate + igstAmount + cgstAmount + sgstAmount);
        }
      }
    }
    
    grandTotal = roundOf(grandTotal);
    setGrandTotal(grandTotal);
    
    // Calculate TCS amount
    let tcsAmount = 0;
    if (TCS && !isNaN(TCS) && parseFloat(TCS) > 0) {
      tcsAmount = grandTotal * (parseFloat(TCS) / 100);
    }
    
    // Calculate total invoice
    let total = grandTotal + tcsAmount + (parseFloat(adjustments) || 0);
    total = roundOf(total);
    setTotalInvoice(total);
    form.setFieldsValue({
      totalInvoice: total,
    });
  }, [itemList, TCS, adjustments, discountType, discountLevel, discountAmount, tax, stateName, gst]);

  useEffect(() => {
    if (
      itemList &&
      itemList?.length > 0 &&
      (itemList[itemList?.length - 1].partNumber.partNumber ||
        itemList[itemList?.length - 1].quantity?.length > 0)
    ) {
      handleAdd();
      setSearch("");
    }
    const selectItem = {};
    for (const item of itemList) {
      selectItem[item.partNumber.id] = item.partNumber;
    }
    setSelectItemObj(selectItem);
  }, [itemList]);

  const getGSTRateFromPrice = ({ price = "", gstPercentage = "" }) => {
    if (price == null || gstPercentage == null) return null;
    const gstRate =
      parseFloat(price) -
      parseFloat(price) * (100 / (100 + parseFloat(gstPercentage)));
    const netRate = price - gstRate;
    return roundOf(gstRate);
  };

  const getGstAmounts = (price, item) => {
    let igstAmount = 0;
    let cgstAmount = 0;
    let sgstAmount = 0;

    const isInterstate = stateName && gst && stateName.slice(0, 2) !== gst.slice(0, 2);

    if (tax === "Tax Inclusive") {
      igstAmount = getGSTRateFromPrice({
        price: price,
        gstPercentage: item.igst || item.gstRate || 0,
      });
      if (isInterstate) {
        cgstAmount = 0;
        sgstAmount = 0;
      } else {
        const gstByTwo = igstAmount / 2;
        sgstAmount = roundOf(gstByTwo);
        cgstAmount = roundOf(gstByTwo);
        igstAmount = 0;
      }
    } else {
      // Tax Exclusive
      const igstRate = parseFloat(item.igst) || parseFloat(item.gstRate) || 0;
      const cgstRate = parseFloat(item.cgst) || (igstRate / 2) || 0;
      const sgstRate = parseFloat(item.sgst) || (igstRate / 2) || 0;

      if (isInterstate) {
        igstAmount = roundOf((price * igstRate) / 100);
        cgstAmount = 0;
        sgstAmount = 0;
      } else {
        cgstAmount = roundOf((price * cgstRate) / 100);
        sgstAmount = roundOf((price * sgstRate) / 100);
        igstAmount = 0;
      }
    }

    return { igstAmount, cgstAmount, sgstAmount };
  };

  const calculateGSTAmount = ({ price = "", gstPercentage = "" }) => {
    if (price == null || gstPercentage == null) return null;
    const gstRate = (price * gstPercentage) / 100;
    const netRate = price + gstRate;
    return roundOf(gstRate);
  };

  // const calculateTransactionTax = () => {
  //   if (discountType !== "At Transaction Level") return;
  //   const newItemList = [...itemList];
  //   let grandTotal = 0;
  //   let totalGstAmount = 0;
  //   if (tax === "Tax Inclusive") {
  //     for (const index in newItemList) {
  //       if (newItemList[index].rate > 0 && newItemList[index].gstRate > 0) {
  //         let total = newItemList[index].rate;

  //         // Apply discount first, then calculate GST on discounted amount
  //         if (
  //           newItemList[index].discount > 0 &&
  //           !isNaN(newItemList[index].discount)
  //         ) {
  //           if (discountLevel === "percent") {
  //             const discountAmount =
  //               (parseFloat(total) * parseFloat(newItemList[index].discount)) /
  //               100;
  //             total = parseFloat(total) - discountAmount;
  //           } else {
  //             total = total - parseFloat(newItemList[index].discount);
  //           }
  //         }

  //         newItemList[index].igstAmount = getGSTRateFromPrice({
  //           price: parseFloat(total),
  //           gstPercentage: newItemList[index].igst,
  //         });

  //         const gstByTwo = roundOf(newItemList[index].igstAmount / 2);
  //         newItemList[index].sgstAmount = gstByTwo;
  //         newItemList[index].cgstAmount = gstByTwo;

  //         newItemList[index].grandTotal = parseFloat(total);
  //       }
  //     }
  //   }
  //   if (tax === "Tax Exclusive") {
  //     for (const index in newItemList) {
  //       if (newItemList[index].rate > 0 && newItemList[index].gstRate > 0) {
  //         let total = parseFloat(newItemList[index].rate);

  //         if (
  //           newItemList[index].discount > 0 &&
  //           !isNaN(newItemList[index].discount)
  //         ) {
  //           total =
  //             discountLevel === "percent"
  //               ? total -
  //                 total * (parseFloat(newItemList[index].discount) / 100)
  //               : total - parseFloat(newItemList[index].discount);
  //         }

  //         newItemList[index].igstAmount = calculateGSTAmount({
  //           price: parseFloat(total),
  //           gstPercentage: newItemList[index].igst,
  //         });

  //         const gstByTwo = roundOf(newItemList[index].igstAmount / 2);
  //         newItemList[index].sgstAmount = gstByTwo;
  //         newItemList[index].cgstAmount = gstByTwo;

  //         total = total + parseFloat(newItemList[index].igstAmount);
  //         newItemList[index].grandTotal = total;
  //       }
  //     }
  //   }
  //   setItemList(newItemList);
  // };

  // const calculateItemTax = () => {
  //   if (discountType !== "At Item Level") return;
  //   let taxExlusive = 0;
  //   let taxInclusive = 0;
  //   let newItemList = [...itemList];
  //   let grandTotal = 0;
  //   if (tax === "Tax Inclusive") {
  //     for (const index in newItemList) {
  //       if (newItemList[index].rate > 0 && newItemList[index].gstRate > 0) {
  //         let total = newItemList[index].rate;
  //         // Calculate GST on discount-applied amount using full GST% and split for CGST/SGST
  //         const cgst = parseFloat(newItemList[index].cgst) || 0;
  //         const sgst = parseFloat(newItemList[index].sgst) || 0;
  //         const igst = parseFloat(newItemList[index].igst) || 0;
  //         const gstRate = cgst + sgst + igst;
  //         const totalGST = total - total / (1 + gstRate / 100);
  //         if (igst > 0) {
  //           newItemList[index].igstAmount = roundOf(totalGST);
  //           newItemList[index].cgstAmount = 0;
  //           newItemList[index].sgstAmount = 0;
  //         } else {
  //           newItemList[index].cgstAmount = roundOf(totalGST / 2);
  //           newItemList[index].sgstAmount = roundOf(totalGST / 2);
  //           newItemList[index].igstAmount = 0;
  //         }
  //         sgstAmt = newItemList[index].sgstAmount;
  //         cgstAmt = newItemList[index].cgstAmount;
  //         igstAmt = newItemList[index].igstAmount;
  //         if (
  //           newItemList[index].discount > 0 &&
  //           !isNaN(newItemList[index].discount)
  //         ) {
  //           if (discountLevel === "percent") {
  //             const priceWithoutGST =
  //               parseFloat(total) - parseFloat(newItemList[index].igstAmount);
  //             const discountPrice =
  //               (priceWithoutGST * parseFloat(newItemList[index].discount)) /
  //               100;
  //             total = parseFloat(total) - discountPrice;
  //           } else {
  //             total = total - parseFloat(newItemList[index].discount);
  //           }
  //         }
  //         setSGSTAmount(sgstAmt);
  //         setIGSTAmount(igstAmt);
  //         setCGSTAmount(cgstAmt);
  //         newItemList[index].grandTotal = parseFloat(total);
  //       }
  //       grandTotal = roundOf(
  //         parseFloat(grandTotal) + parseFloat(newItemList[index].rate)
  //       );
  //     }
  //     setGrandTotal(grandTotal);
  //     setTotalInvoice(grandTotal);
  //     form.setFieldsValue({
  //       totalInvoice: grandTotal,
  //     });
  //   }
  //   if (tax === "Tax Exclusive") {
  //     for (const index in newItemList) {
  //       if (newItemList[index].rate > 0 && newItemList[index].gstRate > 0) {
  //         let total = parseFloat(newItemList[index].rate);
  //         // Calculate GST on discount-applied amount
  //         newItemList[index].igstAmount = roundOf(
  //           (total * (newItemList[index].igst || 0)) / 100
  //         );
  //         const gstByTwo = roundOf(newItemList[index].igstAmount / 2);
  //         newItemList[index].sgstAmount = gstByTwo;
  //         newItemList[index].cgstAmount = gstByTwo;
  //         sgstAmt = newItemList[index].sgstAmount;
  //         cgstAmt = newItemList[index].cgstAmount;
  //         igstAmt = newItemList[index].igstAmount;
  //         if (
  //           newItemList[index].discount > 0 &&
  //           !isNaN(newItemList[index].discount)
  //         ) {
  //           total =
  //             discountLevel === "percent"
  //               ? total -
  //                 total * (parseFloat(newItemList[index].discount) / 100)
  //               : total - parseFloat(newItemList[index].discount);
  //         }
  //         total = total + parseFloat(newItemList[index].igstAmount);
  //         setSGSTAmount(sgstAmt);
  //         setIGSTAmount(igstAmt);
  //         setCGSTAmount(cgstAmt);
  //         newItemList[index].grandTotal = total;
  //       }
  //       grandTotal = roundOf(
  //         parseFloat(grandTotal) + parseFloat(newItemList[index].rate)
  //       );
  //       setGrandTotal(grandTotal);
  //       setTotalInvoice(grandTotal);
  //       form.setFieldsValue({
  //         totalInvoice: grandTotal,
  //       });
  //     }
  //   }
  //   setItemList(newItemList);
  // };

  const renderColumns = () => {
    const columns = [
      {
        title: "S.No",
        key: "index",
        width: 65,
        render: (text, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "Part Details",
        dataIndex: "partNumber",
        key: "partNumber",
        width: 360,
        render: (record, data, key) => (
          <Form.Item>
            <Select
              dropdownStyle={{
                overflowY: "auto",
                overflowX: "hidden",
              }}
              onChange={(event) => {
                setPartSearch(true);
                handlePartDetail(event, data);
              }}
              onSearch={(event) => {
                setSearch(event);
                if (partsData?.length === 1) {
                  const part = partsData[0];
                  if (!(part.id in selectItemObj) || part.id === data.partNumber?.id) {
                    handlePartDetail(part.partNumber, data);
                    partsRef[key].focus();
                  }
                }
              }}
              value={
                record?.partNumber == undefined
                  ? "Part Number"
                  : `${record.partNumber} - ${record.partName}`
              }
              disabled={editable}
              showSearch
              showAction={["click", "focus"]}
              placeholder="Part Number"
              filterOption={(input, option) =>
                option.props.children.some(
                  (child) =>
                    child.toLowerCase().indexOf(input.toLowerCase()) >= 0
                )
              }
            >
              {partsData.map((part) => {
                if (part.id in selectItemObj && part.id !== data.partNumber?.id) return null;
                return (
                  <Select.Option key={part.id} value={part.partNumber}>
                    {part.partNumber} - {part.partName}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        ),
      },
      {
        title: "HSN",
        dataIndex: "hsn",
        key: "hsn",
        width: 80,
        render: (record, index) => (
          <Form.Item>
            <span>{record && record.code}</span>
          </Form.Item>
        ),
      },
      {
        title: "GST%",
        dataIndex: "gstRate",
        key: "gstRate",
        width: 70,
        render: (data, record) => (
          <Form.Item>
            <span>{record && record.gstRate}</span>
          </Form.Item>
        ),
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 80,
        render: (data, record, index) => (
          <Form.Item>
            <Input
              key="quantity"
              disabled={editable}
              onChange={(event) => {
                handleQuantity(event, record);
              }}
              ref={(el) => (partsRef[index] = el)}
              placeholder="quantity"
              value={record && record.quantity}
            />
          </Form.Item>
        ),
      },
      {
        title: "Unit rate",
        dataIndex: "unitRate",
        key: "unitRate",
        width: 100,
        render: (data, record, index) => (
          <Form.Item>
            <Input
              key="unitRate"
              disabled={editable}
              onChange={(event) => {
                handleUnitRate(event, record);
              }}
              placeholder="Unit Rate"
              value={record && record.unitRate}
            />
          </Form.Item>
        ),
      },
      {
        title: "Discount %",
        dataIndex: "discount",
        key: "discount",
        width: 80,
        render: (data, record) => (
          <Form.Item>
            <Input
              key="discount"
              onChange={(event) => {
                handleDiscount(event, record);
              }}
              disabled={editable}
              placeholder="Discount"
              value={record && record.discount}
            />
          </Form.Item>
        ),
      },
      {
        title: "Gross Amount",
        dataIndex: "rate",
        key: "rate",
        width: 120,
        render: (data, record) => (
          <Form.Item>
            <Input
              key="rate"
              disabled={true}
              placeholder="Rate"
              value={
                discountType === "At Transaction Level"
                  ? roundOf(
                    (parseFloat(record.quantity) || 0) *
                    (parseFloat(record.unitRate) || 0) *
                    (1 - (parseFloat(discountAmount) || 0) / 100)
                  )
                  : record && record.rate
              }
            />
          </Form.Item>
        ),
      },
      {
        title: "Action",
        dataIndex: "remove",
        key: "x",
        width: 80,
        render: (data, record) => (
          <Form.Item>
            {itemList.length >= 1 && !editable ? (
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => {
                  handleDelete(record.id);
                }}
              >
                <a style={{ color: "#6c7b8a" }}>Delete</a>
              </Popconfirm>
            ) : null}
          </Form.Item>
        ),
      },
    ];

    return columns.filter((col) =>
      discountType === "At Transaction Level"
        ? col.dataIndex !== "discount"
        : col
    );
  };

  const handleSubmit = () => {
    setFormSubmit(true);
    form.validateFields((validationError) => {
      let totalSGSTAmt = 0;
      let totalCGSTAmt = 0;
      let totalIGSTAmt = 0;
      let newItemList = [...itemList];
      for (let i = 0; i < newItemList.length; i++) {
        const sgstAmtVal = parseFloat(newItemList[i].sgstAmount);
        const cgstAmtVal = parseFloat(newItemList[i].cgstAmount);
        const igstAmtVal = parseFloat(newItemList[i].igstAmount);

        if (!isNaN(sgstAmtVal) && sgstAmtVal > 0) {
          totalSGSTAmt += sgstAmtVal;
        }
        if (!isNaN(cgstAmtVal) && cgstAmtVal > 0) {
          totalCGSTAmt += cgstAmtVal;
        }
        if (!isNaN(igstAmtVal) && igstAmtVal > 0) {
          totalIGSTAmt += igstAmtVal;
        }
        newItemList[i].discountPercent =
          discountLevel === "percent" ? Number(newItemList[i].discount) : 0;
        newItemList[i].discountRate =
          discountLevel === "rupee" ? Number(newItemList[i].discount) : 0;
        newItemList[i].discountAmount =
          discountLevel === "rupee" ? Number(newItemList[i].discount) : 0;
      }
      if (newItemList.length > 1) {
        newItemList = newItemList.filter((item) => {
          return (
            item.partNumber &&
            item.quantity &&
            item.hsn &&
            item.rate &&
            item.igst &&
            item.cgst &&
            item.sgst
          );
        });
      }

      setItemList(newItemList);
      const data = {
        invoiceNumber,
        invoiceDate: invoiceDate,
        currentDate: moment(Date.now()),
        supplierName: modifyType
          ? editData && editData.supplier && editData.supplier.id
          : supplierID,
        itemrate: tax,
        discountType,
        discountPercent: discountLevel === "percent" ? discountAmount : 0,
        discountRate: discountLevel === "rupee" ? discountAmount : 0,
        discountAmount: discountLevel === "rupee" ? discountAmount : 0,
        cgst: stateName.slice(0, 2) === gst.slice(0, 2) ? totalCGSTAmt : null,
        igst: stateName.slice(0, 2) !== gst.slice(0, 2) ? totalIGSTAmt : null,
        sgst: stateName.slice(0, 2) === gst.slice(0, 2) ? totalSGSTAmt : null,
        tcs: TCS,
        totalDiscount,
        totalInvoice,
        adjustments,
        purchaseItemInvoice: newItemList,
        branch: branch && branch.id ? branch.id : branch,
        psiNo: psiNo,
        deletePartData: deletePartData,
      };
      if (validationError === null || itemList.length >= 1) {
        setBtnFlag(true);
        let stop = false;
        if (!modifyType && !stop) {
          platformApi
            .post("/api/purchaseSpareInvoice/", data)
            .then((result) => {
              let { data } = result;
              if (data.code === 200) {
                let { response } = data;
                if (response.code === 200) {
                  message.success("PSI Added Successfully");
                  history.push("/autoadmin/purchase_spares_invoice");
                }
              }
              setBtnFlag(false);
            })
            .catch((err) => {
              message.error("Couldn't Add PSI");
              setBtnFlag(false);
            });
        } else {
          platformApi
            .put(`/api/purchaseSpareInvoice/${id}`, data)
            .then((result) => {
              let { data } = result;
              if (data.code === 200) {
                let { response } = data;
                if (response.code === 200) {
                  message.success("PSI Modified Successfully");
                  history.push("/autoadmin/purchase_spares_invoice");
                }
              }
              setBtnFlag(false);
            })
            .catch((err) => {
              console.error("PSI Add Error: ", err);
              message.error("Couldn't update PSI");
              setBtnFlag(false);
            });
        }
      } else {
        message.error("select atleast one item list");
        setBtnFlag(false);
      }
    });
  };

  const handleCancel = () => {
    form.resetFields();
    setInvoiceDate(null);
    // Setflag(false);
    setInvoiceNumber("");
    setSupplier("");
    setGrandTotal(0);
    setAdjustments(0);
    setTCS(0);
    setDiscountAmount(0);
    setStateName("");
    setGst("");
    setDeletePartData([]);
    setItemList([partItemData]);
    history.push("/autoadmin/purchase_spares_invoice");
  };

  const handleAdd = () => {
    let newArr = [...itemList, partItemData];
    setItemList(newArr);
  };
  const handleDelete = (selectedId) => {
    const deleteSource = itemList.filter((item) => item.id == selectedId);
    const isDeletingValid = deleteSource.some((item) => item.partNumber && (item.partNumber.id || item.partNumber.partNumber));
    const validItems = itemList.filter((item) => item.partNumber && (item.partNumber.id || item.partNumber.partNumber));

    if (itemList.length <= 1 || (isDeletingValid && validItems.length <= 1)) {
      message.error("At least one item required", 2);
      return;
    }

    let grandTotal = 0;
    const updatedDataSource = itemList.filter((item) => item.id !== selectedId);
    for (let i = 0; i < updatedDataSource.length; i++) {
      grandTotal = roundOf(
        parseFloat(grandTotal) + parseFloat(updatedDataSource[i].grandTotal)
      );
      setGrandTotal(grandTotal);
      setTotalInvoice(grandTotal);
      form.setFieldsValue({
        totalInvoice: grandTotal,
      });
    }

    for (let i = 0; i < deleteSource.length; i++) {
      if (deleteSource[i].partNumber.number || deleteSource[i].partNumber.hsn) {
        deletePartData.push(deleteSource[i].partNumber.id);
      }
    }
    setDeletePartData(deletePartData);
    setItemList(updatedDataSource);
  };

  const handleInvoiceDate = (e) => {
    if (e) {
      const date = new Date(e._d);
      setInvoiceDate(moment(date));
    }
  };

  const handleSupplierChange = (supplierID) => {
    setSupplier(supplierID);
    supplier.map((item) => {
      if (item.id === supplierID) {
        setStateName(item.GSTIN);
      }
    });
  };

  const handlePartDetail = (event, data) => {
    const newItemList = [...itemList];
    if (event !== undefined) {
      partsData.map((part) => {
        if (part.partNumber === event) {
          for (let item of newItemList) {
            if (item.id === data.id) {
              item.partNumber = part;
              item.hsn = part.hsn || null;
              item.cgst = part.hsn ? part.hsn.cgst : 0;
              item.igst = part.hsn ? part.hsn.igst : 0;
              item.sgst = part.hsn ? part.hsn.sgst : 0;
              item.gstRate = part.hsn ? (Number(part.hsn.cgst || 0) + Number(part.hsn.sgst || 0)) : 0;
              item.unitRate = part.mrp;
              item.quantity = 1;
              setquantity(1);
              setUnitRate(part.mrp);
              if (item.gstRate === GST18) {
                setGSTRate18(true);
              }
              if (item.gstRate === GST28) {
                setGSTRate28(true);
              }
              if (item.gstRate === GST12) {
                setGSTRate12(true);
              }
              if (item.gstRate === GST5) {
                setGSTRate5(true);
              }
              setCGST(part.hsn ? part.hsn.cgst : 0);
              setSGST(part.hsn ? part.hsn.sgst : 0);
              setIGST(part.hsn ? part.hsn.igst : 0);
              // Calculate initial rate
              if (discountType === "At Item Level") {
                if (discountLevel === "percent" && item.discount > 0) {
                  item.rate =
                    item.quantity * item.unitRate * (1 - item.discount / 100);
                } else if (discountLevel === "rupee" && item.discount > 0) {
                  item.rate = item.quantity * item.unitRate - item.discount;
                } else {
                  item.rate = item.quantity * item.unitRate;
                }
              } else {
                item.rate = item.quantity * item.unitRate;
              }
            }
          }
        }
      });
    }
    setItemList(newItemList);
  };

  const handleQuantity = (event, record) => {
    let val = formatValue(event, "noWithDot");
    setquantity(val);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.quantity = val;
        const qty = parseFloat(item.quantity) || 0;
        const unit = parseFloat(item.unitRate) || 0;
        let rate = qty * unit;
        if (discountType === "At Item Level") {
          const disc = parseFloat(item.discount) || 0;
          if (discountLevel === "percent") {
            rate = qty * unit * (1 - (disc || 0) / 100);
          } else if (discountLevel === "rupee") {
            rate = qty * unit - (disc || 0);
          }
        } else if (discountType === "At Transaction Level") {
          const disc = parseFloat(discountAmount) || 0;
          rate = qty * unit * (1 - disc / 100);
        }
        item.rate = rate;
        const { igstAmount, cgstAmount, sgstAmount } = getGstAmounts(rate, item);
        item.igstAmount = igstAmount;
        item.cgstAmount = cgstAmount;
        item.sgstAmount = sgstAmount;
        break;
      }
    }
    setItemList(newItemList);
  };

  const handleDiscount = (event, record) => {
    let val = formatValue(event, "noWithDot");
    if (discountLevel === "percent" && parseFloat(val) > 100) val = "100";
    setDiscount(val);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.discount = val;
        if (discountType === "At Item Level") {
          const qty = parseFloat(item.quantity) || 0;
          const unit = parseFloat(item.unitRate) || 0;
          const disc = parseFloat(item.discount) || 0;
          let rate = qty * unit;
          if (discountLevel === "percent" && disc > 0) {
            rate = qty * unit * (1 - disc / 100);
          } else if (discountLevel === "rupee" && disc > 0) {
            rate = qty * unit - disc;
          }
          item.rate = rate;
          const { igstAmount, cgstAmount, sgstAmount } = getGstAmounts(rate, item);
          item.igstAmount = igstAmount;
          item.cgstAmount = cgstAmount;
          item.sgstAmount = sgstAmount;
        } else {
          item.rate =
            (parseFloat(item.quantity) || 0) * (parseFloat(item.unitRate) || 0);
        }
        break;
      }
    }
    setItemList(newItemList);
  };

  const handleUnitRate = (event, record) => {
    let val = formatValue(event, "noWithDot");
    setUnitRate(val);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.unitRate = val;
        const qty = parseFloat(item.quantity) || 0;
        const unit = parseFloat(item.unitRate) || 0;
        let rate = qty * unit;
        if (discountType === "At Item Level") {
          const disc = parseFloat(item.discount) || 0;
          if (discountLevel === "percent") {
            rate = qty * unit * (1 - (disc || 0) / 100);
          } else if (discountLevel === "rupee") {
            rate = qty * unit - (disc || 0);
          }
        } else if (discountType === "At Transaction Level") {
          const disc = parseFloat(discountAmount) || 0;
          rate = qty * unit * (1 - disc / 100);
        }
        item.rate = rate;
        const { igstAmount, cgstAmount, sgstAmount } = getGstAmounts(rate, item);
        item.igstAmount = igstAmount;
        item.cgstAmount = cgstAmount;
        item.sgstAmount = sgstAmount;
        break;
      }
    }
    setItemList(newItemList);
  };

  const validateEmptyField = (value) => {
    if (value === "" || value === undefined) {
      return false;
    }
    return true;
  };

  const totalCGSTValue = itemList
    .reduce((sum, item) => sum + (parseFloat(item.cgstAmount) || 0), 0)
    .toFixed(2);
  const totalSGSTValue = itemList
    .reduce((sum, item) => sum + (parseFloat(item.sgstAmount) || 0), 0)
    .toFixed(2);

  useEffect(() => {
    form.setFieldsValue({
      cgst: totalCGSTValue,
      sgst: totalSGSTValue,
    });
  }, [totalCGSTValue, totalSGSTValue]);

  useEffect(() => {
    if (!editable && branch && branch.id) {
      platformApi
        .post("/api/idGenerate/purchaseSpareInvoice", { branch: branch.id })
        .then((result) => {
          let { data } = result;
          if (data.code === 200 && data.response) {
            setPsiNo(data.response.data);
          }
        });
    }
  }, [editable, branch]);

  useEffect(() => {
    if (discountType === "At Item Level") {
      let updated = false;
      const newItemList = itemList.map((item) => {
        const qty = parseFloat(item.quantity) || 0;
        const unit = parseFloat(item.unitRate) || 0;
        const disc = parseFloat(item.discount) || 0;
        let original = qty * unit;
        let discounted = original;
        if (discountLevel === "percent" && disc > 0) {
          discounted = original * (1 - disc / 100);
        } else if (discountLevel === "rupee" && disc > 0) {
          discounted = original - disc;
        }
        // Only update if changed
        if (item.rate !== discounted) updated = true;
        return { ...item, rate: discounted };
      });
      if (updated) setItemList(newItemList);
    }
  }, [itemList, discountType, discountLevel]);

  // Add a useEffect to recalculate GST for all items when itemList, tax, or discountType changes and discountType is 'At Item Level'
  useEffect(() => {
    if (discountType !== "At Item Level") return;
    let changed = false;
    const newItemList = itemList.map((item) => {
      const qty = parseFloat(item.quantity) || 0;
      const unit = parseFloat(item.unitRate) || 0;
      const disc = parseFloat(item.discount) || 0;
      let rate = qty * unit;
      if (discountLevel === "percent" && disc > 0) {
        rate = qty * unit * (1 - disc / 100);
      } else if (discountLevel === "rupee" && disc > 0) {
        rate = qty * unit - disc;
      }
      
      const { igstAmount, cgstAmount, sgstAmount } = getGstAmounts(rate, item);
      const newRate = roundOf(rate);

      if (
        item.rate !== newRate ||
        item.igstAmount !== igstAmount ||
        item.cgstAmount !== cgstAmount ||
        item.sgstAmount !== sgstAmount
      ) {
        changed = true;
      }

      return {
        ...item,
        rate: newRate,
        igstAmount,
        cgstAmount,
        sgstAmount,
      };
    });
    if (changed) {
      setItemList(newItemList);
    }
  }, [itemList, tax, discountType, discountLevel, stateName, gst]);

  // Calculate total discount amount for both discount types
  useEffect(() => {
    let total = 0;
    if (
      (discountType === "At Transaction Level" &&
        parseFloat(discountAmount) > 0) ||
      discountType === "At Item Level"
    ) {
      total = itemList.reduce((sum, item) => {
        const base =
          (parseFloat(item.unitRate) || 0) * (parseFloat(item.quantity) || 0);
        const discount = base - (parseFloat(item.rate) || 0);
        return sum + (discount > 0 ? discount : 0);
      }, 0);
    }
    setTotalDiscount(total);
  }, [itemList, discountType, discountAmount]);

  return (
    <>
      <Form className="purchase-form">
        <Row>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Internal PSI Number"
              name="psiNo"
            >
              <Input
                disabled={true}
                value={psiNo}
                placeholder="Internal PSI Number"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Invoice Date"
              name="invoiceDate"
              required
              validateStatus={
                formSubmit &&
                (validateEmptyField(invoiceDate) ? "success" : "error")
              }
              help={
                formSubmit &&
                !validateEmptyField(invoiceDate) &&
                "Enter Invoice Date"
              }
            >
              <DatePicker
                allowClear
                format={dateFormatList}
                value={invoiceDate ? moment(invoiceDate) : null}
                onChange={(e) => handleInvoiceDate(e)}
                disabledDate={(moment) => Date.now() < moment._d}
              />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item
              className="purchase-form-element"
              label="Location"
              name="branch"
              required
            >
              <Select
                dropdownStyle={{
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
                value={branch && branch.id ? branch.id : branch}
                onChange={(branchId) => {
                  const selectedBranch = branchOptions.find(
                    (b) => b.id === branchId
                  );
                  setBranch(selectedBranch || { id: branchId, name: branchId });
                }}
                showAction={["click", "focus"]}
                showSearch
                placeholder="Branch"
                filterOption={null}
              >
                {branchOptions.map((eachBranch) => (
                  <Select.Option key={eachBranch.id} value={eachBranch.id}>
                    {eachBranch.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Supplier"
              name="supplier"
              required
              validateStatus={
                formSubmit &&
                (validateEmptyField(supplierID) ? "success" : "error")
              }
              help={
                formSubmit &&
                !validateEmptyField(supplierID) &&
                "Select Supplier"
              }
            >
              <Select
                dropdownStyle={{
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
                // value={editable ? editData && editData.supplier.name : supplierName}
                value={supplierID}
                onChange={(value) => {
                  handleSupplierChange(value);
                }}
                showAction={["click", "focus"]}
                showSearch
                disabled={editable}
                placeholder="Supplier"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {supplier.map((supply) => (
                  <Select.Option key={supply.id} value={supply.id}>
                    {supply.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Invoice Number"
              name="invoiceNumber"
              required
              validateStatus={
                invoiceNumberError
                  ? "error"
                  : formSubmit &&
                  (validateEmptyField(invoiceNumber) ? "success" : "error")
              }
              help={
                invoiceNumberError ||
                (formSubmit &&
                  !validateEmptyField(invoiceNumber) &&
                  "Enter Invoice Number")
              }
              rules={[
                {
                  required: true,
                  message: "Enter Invoice Number",
                },
              ]}
            >
              <Input
                placeholder="Enter invoice number"
                className="form-input"
                disabled={editable || !supplierID}
                onChange={async (e) => {
                  const value = e.target.value.replace(/[^a-zA-Z0-9\-/]/g, "");
                  setInvoiceNumber(value);
                  setInvoiceNumberError("");
                  if (!value || !supplierID) return;
                  try {
                    const res = await platformApi.post(
                      "/api/purchaseSpareInvoice/checkDuplicateInvoiceNo",
                      { invoiceNumber: value, supplierId: supplierID }
                    );
                    let { data } = res;
                    if (editData) {
                      if (
                        data.duplicate &&
                        data.data.invoiceNumber != editData.invoiceNumber
                      ) {
                        setInvoiceNumberError("Invoice Number already exists");
                      } else {
                        setInvoiceNumberError("");
                      }
                    } else {
                      if (data.duplicate) {
                        setInvoiceNumberError("Invoice Number already exists");
                      } else {
                        setInvoiceNumberError("");
                      }
                    }
                  } catch (err) {
                    setInvoiceNumberError("");
                  }
                }}
                value={invoiceNumber}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <Form.Item
              className="form-element-type"
              label="Item Rates Are"
              name="itemRates"
              validateStatus={
                formSubmit && (validateEmptyField(tax) ? "success" : "error")
              }
              help={
                formSubmit && !validateEmptyField(tax) && "Select Item rates"
              }
            >
              <Select
                value={tax}
                showSearch
                showAction={["click", "focus"]}
                style={{ width: 200 }}
                placeholder="Select Item Rate"
                disabled={editable}
                onChange={(value) => setTax(value)}
              >
                <Option value="Tax Inclusive">Tax Inclusive</Option>
                <Option value="Tax Exclusive">Tax Exclusive</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              className="form-element-type"
              label="Discount Type"
              name="dicountType"
            >
              <Select
                showSearch
                showAction={["click", "focus"]}
                style={{ width: 200 }}
                disabled={editable}
                placeholder="Select Discount Type"
                onChange={(value) => setDiscountType(value)}
                value={discountType}
              >
                <Option value="At Transaction Level">
                  At Transaction Level
                </Option>
                <Option value="At Item Level">At Item Level</Option>
              </Select>
            </Form.Item>
          </Col>
          {/* <Col span={6}>
            <Form.Item
              className="form-element-type"
              label="Discount"
              name="discountLevel"
            >
              <span style={{ fontWeight: 500, fontSize: 16 }}>%</span>
            </Form.Item>
          </Col> */}
          {discountType === "At Transaction Level" && (
            <Col span={6}>
              <Form.Item
                className="form-element-type"
                label="Discount Percentage"
                name="discountAmount"
                onChange={(e) => {
                  let val = formatValue(e, "noWithDot");
                  if (parseFloat(val) > 100) val = "100";
                  setDiscountAmount(val);
                }}
                rules={[{}]}
              >
                <Input
                  disabled={editable}
                  placeholder="Discount Amount"
                  value={discountAmount}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Table
          className="parts-invoice-table"
          rowKey={(record) => {
            record.id;
          }}
          columns={renderColumns()}
          dataSource={itemList}
          tableLayout="fixed"
          pagination={false}
          style={{ marginTop: "1rem", marginBottom: "1rem" }}
        />
        <br />
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item className="form-element" label="CGST">
              {getFieldDecorator("cgst", {
                rules: [
                  {
                    required: false,
                    message: "Enter CGST",
                  },
                ],
              })(
                <Input
                  placeholder="CGST"
                  disabled={true}
                  value={totalCGSTValue}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item className="form-element" label="SGST">
              {getFieldDecorator("sgst", {
                rules: [
                  {
                    required: false,
                    message: "Enter SGST",
                  },
                ],
              })(
                <Input
                  placeholder="SGST"
                  disabled={true}
                  value={totalSGSTValue}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item
              className="form-element"
              label="Total Discount"
              name="totalDiscount"
              rules={[{}]}
            >
              <Input
                placeholder="Total Discount"
                value={(Number(totalDiscount) || 0).toFixed(2)}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <div className="gst-table">
              <Title level={4} className="gst-title">
                GST Data
              </Title>
              <GSTTable
                gst={gst}
                SGST={SGST}
                CGST={CGST}
                IGST={IGST}
                itemList={itemList}
                GSTRate18={GSTRate18}
                GSTRate28={GSTRate28}
                GSTRate5={GSTRate5}
                GSTRate12={GSTRate12}
                stateName={stateName}
              />
            </div>
          </Col>
          <Col span={8}>
            <Form.Item
              className="form-element"
              label="Grand Total"
              name="grandTotal"
            >
              <Input
                disabled={true}
                placeholder="Grand Total"
                value={grandTtl}
              />
            </Form.Item>
            <Form.Item
              className="form-element"
              label="TCS"
              name="tcs"
              rules={[{}]}
            >
              <Input
                disabled={editable}
                placeholder="TCS"
                value={TCS}
                onChange={(e) => setTCS(formatValue(e, "noWithDot"))}
              />
            </Form.Item>
            <Form.Item
              className="form-element"
              label="Adjustments"
              name="adjustments"
              rules={[{}]}
            >
              <Input
                disabled={editable}
                placeholder="Adjustment"
                value={adjustments}
                onChange={(e) => setAdjustments(formatValue(e, "noWithDot"))}
              />
            </Form.Item>
            <Form.Item
              className="form-element"
              label="Total Invoice"
              name="totalInvoice"
              rules={[{}]}
            >
              {getFieldDecorator("totalInvoice", {
                rules: [{ required: false, message: "" }],
              })(<Input disabled={true} placeholder="Total Invoice" />)}
            </Form.Item>
          </Col>
        </Row>
        <div style={{ float: "right" }}>
          <Button
            style={{ marginRight: "1rem" }}
            size="large"
            onClick={() => handleCancel()}
          >
            Cancel
          </Button>
          {(editable && !modifyAccess) ? null : (
            <Button
              type="primary"
              disabled={btnFlag || !!invoiceNumberError}
              size="large"
              onClick={() => (!editable ? handleSubmit() : onEdit(false))}
            >
              {!editable ? "Save" : "Modify"}
            </Button>
          )}
        </div>
      </Form>
    </>
  );
};

const WrappedInvoiceForm = Form.create()(InvoiceForm);

export default WrappedInvoiceForm;
